import { Guid, Nillable } from '@web/utils';

export class AdminBoxSaleGroupCosmetic {
  public constructor(
    private readonly data: {
      amount?: Nillable<number>;
      availableQuantity?: Nillable<number>;
      remainingQuantity?: Nillable<number>;
      cosmeticBrandName?: Nillable<string>;
      featureFileAlt?: Nillable<string>;
      featureFileUrl?: Nillable<string>;
      id: Guid;
      name: string;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get name(): string {
    return this.data.name;
  }

  public get availableQuantity(): Nillable<number> {
    return this.data.availableQuantity;
  }

  public get amount(): Nillable<number> {
    return this.data.amount;
  }

  public get remainingQuantity(): Nillable<number> {
    return this.data.remainingQuantity;
  }

  public get cosmeticBrandName(): Nillable<string> {
    return this.data.cosmeticBrandName;
  }

  public get featureFileUrl(): Nillable<string> {
    return this.data.featureFileUrl;
  }

  public get featureFileAlt(): Nillable<string> {
    return this.data.featureFileAlt;
  }

  public withAvailableQuantity(
    availableQuantity: Nillable<number>,
  ): AdminBoxSaleGroupCosmetic {
    return new AdminBoxSaleGroupCosmetic({
      amount: this.amount,
      availableQuantity,
      remainingQuantity: this.remainingQuantity,
      cosmeticBrandName: this.cosmeticBrandName,
      featureFileAlt: this.featureFileAlt,
      featureFileUrl: this.featureFileUrl,
      id: this.id,
      name: this.name,
    });
  }

  public withQuantities(data: {
    amount: Nillable<number>;
    availableQuantity: Nillable<number>;
  }): AdminBoxSaleGroupCosmetic {
    return new AdminBoxSaleGroupCosmetic({
      amount: data.amount,
      availableQuantity: data.availableQuantity,
      remainingQuantity: this.remainingQuantity,
      cosmeticBrandName: this.cosmeticBrandName,
      featureFileAlt: this.featureFileAlt,
      featureFileUrl: this.featureFileUrl,
      id: this.id,
      name: this.name,
    });
  }
}
